<template lang="pug">
.d-flex.gap-8
  masked-input(
    v-bind="attrs"
    v-on="$listeners"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(
        :name="name"
        v-bind="data"
      )
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")

  template(v-if="showFetchButton")
    app-button(
      color="redesignPrimary"
      @click="fetchByInn"
    ) Подставить данные
      v-icon(
        right
      ) mdi-sync
</template>

<script>
import MaskedInput from '@/components/user-redesign/inputs/MaskedInput.vue';

const MASK = '############';
const FETCH_WHEN_REACH_SYMBOLS = [10, 12];
const MAX_SYMBOLS = 12;

export default {
  name: 'InnInput',
  components: {
    MaskedInput,
  },
  props: {
    hideFetchAction: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    attrs() {
      return {
        label: 'ИНН',
        mask: MASK,
        normalize: this.normalize,
        counter: MAX_SYMBOLS,
        ...this.$attrs,
      };
    },
    value() {
      return this.attrs.value;
    },
    showFetchButton() {
      return !this.hideFetchAction && FETCH_WHEN_REACH_SYMBOLS.includes(this.value.length);
    },
  },
  watch: {
    value(v) {
      if (!FETCH_WHEN_REACH_SYMBOLS.includes(v.length)) {
        return;
      }

      this.$emit('input:complete');
    },
  },
  created() {},
  methods: {
    normalize(value) {
      return value.replace(/\D/g, '');
    },
    fetchByInn() {
      const payload = {
        query: this.value,
      };

      this.$api.dadata
        .getDataByINN(payload)
        .then((response) => {
          const { suggestions } = response.data;
          if (!suggestions.length) {
            this.$toast.error('По введенному ИНН организация не найдена');
            return;
          }

          const [suggestion] = suggestions;

          const data = {
            head_full_name: suggestion.data.management.name,
            short_name: suggestion.data.name?.short_with_opf,
            full_name: suggestion.data.name?.full_with_opf,
            legal_address: suggestion.data.address.value,
            fact_address: suggestion.data.address.value,
          };

          this.$emit('data-by-inn', data);
        })
        .catch(() => {
          this.$toast.error('Ошибка при получении данных организации');
        });
    },
  },
};
</script>
